export default __webpack_public_path__ + "static/media/damage.5ee76c92.pdf";